// External Dependencies
import { useDispatch, useSelector } from 'react-redux';
import { useElements, useStripe } from '@stripe/react-stripe-js';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import PropTypes from 'prop-types';

// Internal Dependencies
import { selectIsPosting } from '../../state/selectors/selectors';
import { setTestId } from '../../util/testUtils';
import { submitStripePayment } from '../../state/actions/stripe-actions';

const propTypes = {
  paymentAmount: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
};

const defaultProps = {
  paymentAmount: '',
};

const ConfirmAchPaymentButton = ({ paymentAmount, onSubmit }) => {
  const stripe = useStripe();
  const elements = useElements();

  const dispatch = useDispatch();

  const isPosting = useSelector(selectIsPosting);
  const isPayButtonDisabled = isPosting;

  const handleSubmit = () => {
    dispatch(submitStripePayment(stripe, elements)).then(() => onSubmit());
  };

  return (
    <Button
      color="secondary"
      disabled={isPayButtonDisabled}
      onClick={handleSubmit}
      {...setTestId('confirmPayInvoice')}
    >
      {isPosting ? (
        <CircularProgress color="inherit" size={25} />
      ) : (
        `Pay ${paymentAmount}`
      )}
    </Button>
  );
};

ConfirmAchPaymentButton.propTypes = propTypes;
ConfirmAchPaymentButton.defaultProps = defaultProps;

export default ConfirmAchPaymentButton;
